import { useMutation, UseMutationOptions } from "react-query";

import {
  Response_ValidateUserEmailResponse_,
  UsersService,
  ValidateUserEmailRequest,
} from "../api/public";

export const useValidateUserEmail = (
  options?: UseMutationOptions<
    Response_ValidateUserEmailResponse_,
    unknown,
    ValidateUserEmailRequest,
    unknown
  >
) => {
  return useMutation(
    (request: ValidateUserEmailRequest) =>
      UsersService.usersValidateUserEmail(request),
    options
  );
};
